/**
 * 未登录 可访问
 */
export const noLoginRouterList = [
  '/',
  '/lr',
  '/login',
  '/register',
  '/setpwd',
  '/switchTheme',
  '/forget',
  '/userAgreement',
  '/privacyPolicy',
  '/changePassword',
  '/no-wallet'
]
